export default __webpack_public_path__ + "locales/pt/DeleteDialog.json?hash=ded8a61e5dd8d7000026427037b668c5";